import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AuthRoutingModule } from "src/app/core/modules/auth/auth-routing.module";
import { AuthGuard } from "src/app/core/modules/auth/services/auth-guard.service";
import { AuthService } from "src/app/core/modules/auth/services/auth.service";
import { LandingpageComponent } from "./components/landingpage.component";

@NgModule({
  declarations: [LandingpageComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule],

  providers: [],
})
export class LandingpageModule {}
